import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/locationgcc/dxb/uk/uk_list_banner.webp";
import Bannerfrom from "../../components/bannerfrom";

function Banner() {
  return (
    <div
      className="locationgcc_banner uk_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1>
                Your Partner for Digital Transformation Success in
                <span> UK</span>
              </h1>
              <p className="main_para">
                As industry leaders, TekRevol pioneers digital excellence,
                crafting innovative web and mobile experiences in the UK. Our
                commitment to driving digital evolution is evident in every
                project, as we continuously push boundaries, setting new
                standards for the future of technology in the region.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                 Let’s Connect!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
